import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { catalogUERBaseCostEstimateBasisGql } from '../../../catalogUerBaseCostQueries';

interface IUseCatalogUERBaseCostEstimateBasis {
    catalogUniqueId?: string;
    uerBaseCostId?: number;
    withEffect?: boolean;
}

const requestId = 'catalogUERBaseCostEstimateBasis';

export const useCatalogUERBaseCostEstimateBasis = (props: IUseCatalogUERBaseCostEstimateBasis) => {
    const { catalogUniqueId, uerBaseCostId, withEffect } = props;

    const variables = useMemo(
        () => (catalogUniqueId && uerBaseCostId ? { catalogUniqueId, uerBaseCostId } : undefined),
        [catalogUniqueId, uerBaseCostId],
    );

    const [catalogUERBaseCostEstimateBasisReset] = useResetStoreData({ requestId });

    const [catalogUERBaseCostEstimateBasisData, catalogUERBaseCostEstimateBasisStatus] = useRequest({
        requestId,
        query: catalogUERBaseCostEstimateBasisGql,
        variables,
        withEffect: !!variables && withEffect,
    });

    useEffect(() => {
        catalogUERBaseCostEstimateBasisReset(undefined);
    }, [catalogUERBaseCostEstimateBasisReset]);

    const items = useMemo(
        () => catalogUERBaseCostEstimateBasisData?.catalogUERBaseCostEstimateBasis?.items || [],
        [catalogUERBaseCostEstimateBasisData?.catalogUERBaseCostEstimateBasis],
    );

    return {
        status: catalogUERBaseCostEstimateBasisStatus,
        items,
    };
};
